export default {
  TS_ADJUST_EVENT_LOGS: {
    path: '/ts-adjust-event-logs',
    name: 'ts_adjust_event_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/AdjustEventLogs')
  },
  TS_CLAIMS: {
    path: '/ts-claims',
    name: 'ts_claims',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ts',
      title: 'Claims',
      order: 2
    },
    component: () => import('@ts_views/Claims/ClaimsIndex')
  },
  TS_COHORT_ANALYSIS: {
    path: '/ts-cohort-analysis',
    name: 'ts_cohort_analysis',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/CohortAnalysis/CohortAnalysisIndex.vue')
  },
  TS_COHORT_ANALYSIS_EXPORT: {
    type: 'function',
    path: 'ts_cohort_analysis_export',
    name: 'ts_cohort_analysis_export',
    permission: 'ts_cohort_analysis_export',
    meta: {
      requiresAuth: true
    }
  },
  TS_EMAILS: {
    path: '/ts-emails',
    name: 'ts_emails',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ts',
      title: 'E-Mails',
      order: 3
    },
    component: () => import('@ts_views/Emails/EmailsIndex')
  },
  TS_PERFORMANCE: {
    path: '/ts-performance',
    name: 'ts_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/Performance/PerformanceIndex')
  },
  TS_PERFORMANCE_EXPORT: {
    type: 'function',
    path: 'ts_performance_export',
    name: 'ts_performance_export',
    permission: 'ts_performance_export',
    meta: {
      requiresAuth: true
    }
  },
  TS_REWARDS: {
    path: '/ts-rewards',
    name: 'ts_rewards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/Rewards')
  },
  TS_TRANSACTIONS: {
    path: '/ts-transactions',
    name: 'ts_transactions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ts',
      title: 'Transactions',
      order: 1
    },
    component: () => import('@ts_views/Transactions/TransactionsIndex')
  },
  TS_AFFILIATE_PARTNERS: {
    path: '/ts-affiliate-partners',
    name: 'ts_affiliate_partners',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/AffiliatePartners/AffiliatePartnersIndex')
  },
  TS_USERS: {
    path: '/ts-users',
    name: 'ts_users',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/Users/UsersIndex')
  },
  TS_USERS_EXPORT: {
    type: 'function',
    path: 'ts_users_export',
    name: 'ts_users_export',
    permission: 'ts_users_export',
    meta: {
      requiresAuth: true
    }
  },
  TS_USERS_DELETE: {
    type: 'function',
    path: 'ts_users_delete',
    name: 'ts_users_delete',
    permission: 'ts_users_delete',
    meta: {
      requiresAuth: true
    }
  },
  TS_USER_DETAILS: {
    path: '/ts-user/:userId',
    name: 'ts_user_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ts',
      title: 'User Details',
      order: 0,
      main: true
    },
    component: () => import('@ts_views/Users/UserDetails')
  },
  TS_TRIGGERS: {
    path: '/ts-triggers',
    name: 'ts_triggers',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/Triggers/TriggersIndex')
  },
  TS_LOG_SPEND: {
    path: '/ts-log-spend',
    name: 'ts_log_spend',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/LogSpend')
  },
  TS_OFFER_WALL_PERFORMANCE: {
    path: '/ts-offerwall-performance',
    name: 'ts_offer_wall_performance',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ts',
      title: 'Offerwall Performance',
      order: 6
    },
    component: () => import('@ts_views/OfferWallPerformance')
  },
  TS_BONUS_CODES: {
    path: '/ts-bonus-codes',
    name: 'ts_bonus_codes',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/BonusCodes/BonusCodesIndex.vue')
  },
  TS_BONUS_CODE_REDEMPTIONS: {
    path: '/ts-bonus-code-redemptions',
    name: 'ts_bonus_code_redemptions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ts',
      title: 'Bonus Codes',
      order: 4
    },
    component: () => import('@ts_views/BonusCodeRedemptions')
  },
  TS_SETTINGS: {
    path: '/ts-settings',
    name: 'ts_settings',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/Settings')
  },
  TS_FRONTEND_SETTINGS: {
    path: '/ts-frontend-settings',
    name: 'ts_frontend_settings',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ps_views/shared/frontend-settings/FrontendSettingsIndex.vue')
  },
  TS_CAMPAIGN_SETTINGS: {
    path: '/ts-campaign-settings',
    name: 'ts_campaign_settings',
    meta: { requiresAuth: true },
    props: { project: 'top-surveys' },
    component: () => import('@ps_views/shared/campaign-settings/CampaignSettingsIndex.vue')
  },
  TS_TUNE_REJECTION_SETTINGS: {
    path: '/ts-tune-rejection-settings',
    name: 'ts_tune_rejection_settings',
    meta: { requiresAuth: true },
    props: { project: 'top-surveys' },
    component: () => import('@ps_views/shared/tune-rejection-settings/TuneRejectionSettingsIndex.vue')
  },
  TS_TUNE_REJECTIONS: {
    path: '/ts-tune-rejections',
    name: 'ts_tune_rejections',
    meta: { requiresAuth: true },
    component: () => import('@ts_views/TuneRejections')
  },
  TS_ADJUST_CONFIG: {
    path: '/ts-adjust-config',
    name: 'ts_adjust_config',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ps_views/shared/adjust-config/AdjustConfigIndex.vue')
  },
  TS_USER_CREDIT: {
    type: 'function',
    path: 'ts_user_credit',
    name: 'ts_user_credit',
    permission: 'ts_user_credit',
    meta: {
      requiresAuth: true
    }
  },
  TS_OVERWRITE_ELIGIBLE: {
    type: 'function',
    path: 'ts_overwrite_eligible',
    name: 'ts_overwrite_eligible',
    permission: 'ts_overwrite_eligible',
    meta: {
      requiresAuth: true
    }
  },
  TS_DYNAMIC_CAMPAIGNS: {
    path: '/ts-dynamic-campaigns',
    name: 'ts_dynamic_campaigns_main',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns')
  },
  TS_DYNAMIC_CAMPAIGNS_EMAILS: {
    path: '/ts-dynamic-campaigns/emails',
    name: 'ts_dynamic_campaigns_emails',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns/Pages/Emails/CampaignsEmails.vue')
  },
  TS_DYNAMIC_CAMPAIGNS_EMAILS_CREATE: {
    path: '/ts-dynamic-campaigns/emails/create',
    name: 'ts_dynamic_campaigns_emails_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  TS_DYNAMIC_CAMPAIGNS_EMAILS_EDIT: {
    path: '/ts-dynamic-campaigns/emails/edit/:id',
    name: 'ts_dynamic_campaigns_emails_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  TS_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT: {
    path: '/ts-dynamic-campaigns/emails/:id/translations/edit/:language_code',
    name: 'ts_dynamic_campaigns_emails_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsTranslationsEdit.vue')
  },
  TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS: {
    path: '/ts-dynamic-campaigns/push-notifications',
    name: 'ts_dynamic_campaigns_push_notifications',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotifications.vue')
  },
  TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE: {
    path: '/ts-dynamic-campaigns/push-notifications/create',
    name: 'ts_dynamic_campaigns_push_notifications_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT: {
    path: '/ts-dynamic-campaigns/push-notifications/edit/:id',
    name: 'ts_dynamic_campaigns_push_notifications_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT: {
    path: '/ts-dynamic-campaigns/push-notifications/:id/translations/edit/:language_code',
    name: 'ts_dynamic_campaigns_push_notifications_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'top-surveys' },
    component: () => import('@ts_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsTranslationsEdit.vue')
  },
  TS_USER_REWARD_ELIGIBILITY_LOGS: {
    path: '/ts-user-reward-eligibility-logs',
    name: 'ts_user_reward_eligibility_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ts_views/Users/UserRewardEligibilityLogs')
  }
}
